(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arabic-iphone-launch"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('promo-trio-v2')) {
    customElements.define('promo-trio-v2', class extends HTMLElement {
      connectedCallback() {
        this.cleanup();
        this.events = new AbortController();
        this.setupCountdown();
        this.setupVideo();
      }

      disconnectedCallback() {
        this.cleanup();
        this.video?.pause();
      }

      cleanup() {
        window.clearInterval(this.interval);
        this.interval = null;
        this.events?.abort();
      }

      setupCountdown() {
        const timers = Array.from(this.querySelectorAll('[data-countdown]'));
        if (!timers.length) return;

        const inEditor = this.dataset.editor === 'true';
        const shape = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|[+-]\d{2}:\d{2})$/i;

        const parseDeadline = (value) => {
          const raw = (value || '').trim();
          const parts = raw.match(shape);
          const parsed = Date.parse(raw);
          const validCalendar = parts && Number(parts[1]) >= 1000
            && Number(parts[2]) >= 1 && Number(parts[2]) <= 12
            && Number(parts[3]) >= 1
            && Number(parts[3]) <= new Date(Date.UTC(Number(parts[1]), Number(parts[2]), 0)).getUTCDate()
            && Number(parts[4]) <= 23 && Number(parts[5]) <= 59 && Number(parts[6]) <= 59;
          return validCalendar && Number.isFinite(parsed) ? parsed : null;
        };

        const groups = [];

        timers.forEach(timer => {
          const units = timer.querySelector('[data-units]');
          const error = timer.querySelector('[data-date-error]');
          const expired = timer.querySelector('[data-expired]');
          const deadline = parseDeadline(timer.dataset.end);

          if (deadline === null) {
            timer.hidden = !inEditor;
            if (units) units.hidden = true;
            if (expired) expired.hidden = true;
            if (error) error.hidden = false;
            return;
          }

          timer.hidden = false;
          if (units) units.hidden = false;
          if (error) error.hidden = true;

          groups.push({
            deadline,
            expired,
            fields: ['days', 'hours', 'minutes', 'seconds'].map(key => timer.querySelector(`[data-${key}]`))
          });
        });

        if (!groups.length) return;

        const update = () => {
          const now = Date.now();
          let running = 0;

          groups.forEach(group => {
            const remaining = Math.max(0, Math.ceil((group.deadline - now) / 1000));
            if (remaining > 0) running += 1;
            const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
            group.fields.forEach((field, index) => {
              if (!field) return;
              const value = String(values[index]).padStart(2, '0');
              if (field.textContent !== value) field.textContent = value;
              field.dataset.digits = String(Math.min(value.length, 4));
            });
            if (group.expired) group.expired.hidden = remaining > 0 || !group.expired.textContent.trim();
          });

          if (running === 0) {
            window.clearInterval(this.interval);
            this.interval = null;
          }
          return running;
        };

        if (update() > 0) this.interval = window.setInterval(update, 1000);
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) update();
        }, { signal: this.events.signal });
      }

      setupVideo() {
        this.video = this.querySelector('video');
        const button = this.querySelector('[data-video-toggle]');
        if (!this.video || !button) return;

        const video = this.video;
        const playIcon = button.querySelector('[data-play-icon]');
        const pauseIcon = button.querySelector('[data-pause-icon]');
        const syncButton = () => {
          button.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
          playIcon.toggleAttribute('hidden', !video.paused);
          pauseIcon.toggleAttribute('hidden', video.paused);
        };
        const options = { signal: this.events.signal };
        video.muted = true;
        button.hidden = false;
        button.addEventListener('click', () => {
          if (video.paused) video.play().catch(syncButton);
          else video.pause();
        }, options);
        video.addEventListener('play', syncButton, options);
        video.addEventListener('pause', syncButton, options);
        video.addEventListener('error', () => { button.hidden = true; }, options);

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const respectMotion = () => {
          if (reduceMotion.matches) {
            video.autoplay = false;
            video.pause();
          }
        };
        reduceMotion.addEventListener('change', respectMotion, options);
        if (reduceMotion.matches) respectMotion();
        else video.play().catch(syncButton);
        syncButton();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iphone-launch-2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('promo-trio-section')) {
    customElements.define('promo-trio-section', class extends HTMLElement {
      connectedCallback() {
        this.cleanup();
        this.events = new AbortController();
        this.setupCountdown();
        this.setupVideo();
      }

      disconnectedCallback() {
        this.cleanup();
        this.video?.pause();
      }

      cleanup() {
        window.clearInterval(this.interval);
        this.interval = null;
        this.events?.abort();
      }

      setupCountdown() {
        const timers = Array.from(this.querySelectorAll('[data-countdown]'));
        if (!timers.length) return;

        const raw = (timers[0].dataset.end || '').trim();
        const parts = raw.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|[+-]\d{2}:\d{2})$/i);
        const deadline = Date.parse(raw);
        const validCalendar = parts && Number(parts[1]) >= 1000
          && Number(parts[2]) >= 1 && Number(parts[2]) <= 12
          && Number(parts[3]) >= 1
          && Number(parts[3]) <= new Date(Date.UTC(Number(parts[1]), Number(parts[2]), 0)).getUTCDate()
          && Number(parts[4]) <= 23 && Number(parts[5]) <= 59 && Number(parts[6]) <= 59;

        const groups = timers.map((timer, index) => {
          const expired = timer.querySelector('[data-expired]');
          if (expired && index > 0) expired.removeAttribute('role');
          return {
            timer,
            units: timer.querySelector('[data-units]'),
            error: timer.querySelector('[data-date-error]'),
            expired,
            fields: ['days', 'hours', 'minutes', 'seconds'].map(key => timer.querySelector(`[data-${key}]`))
          };
        });

        if (!validCalendar || !Number.isFinite(deadline)) {
          const inEditor = this.dataset.editor === 'true';
          groups.forEach((group, index) => {
            group.timer.hidden = !inEditor;
            if (group.units) group.units.hidden = true;
            if (group.expired) group.expired.hidden = true;
            if (group.error) group.error.hidden = index !== 0;
          });
          return;
        }

        groups.forEach(group => {
          group.timer.hidden = false;
          if (group.units) group.units.hidden = false;
          if (group.error) group.error.hidden = true;
        });

        const update = () => {
          const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
          const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
          const text = values.map(value => String(value).padStart(2, '0'));
          groups.forEach(group => {
            group.fields.forEach((field, index) => {
              if (!field) return;
              if (field.textContent !== text[index]) field.textContent = text[index];
              field.dataset.digits = String(Math.min(text[index].length, 4));
            });
            if (group.expired) group.expired.hidden = remaining > 0 || !group.expired.textContent.trim();
          });
          if (remaining === 0) {
            window.clearInterval(this.interval);
            this.interval = null;
          }
          return remaining;
        };

        if (update() > 0) this.interval = window.setInterval(update, 1000);
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) update();
        }, { signal: this.events.signal });
      }

      setupVideo() {
        this.video = this.querySelector('video');
        const button = this.querySelector('[data-video-toggle]');
        if (!this.video || !button) return;

        const video = this.video;
        const playIcon = button.querySelector('[data-play-icon]');
        const pauseIcon = button.querySelector('[data-pause-icon]');
        const syncButton = () => {
          button.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
          playIcon.toggleAttribute('hidden', !video.paused);
          pauseIcon.toggleAttribute('hidden', video.paused);
        };
        const options = { signal: this.events.signal };
        video.muted = true;
        button.hidden = false;
        button.addEventListener('click', () => {
          if (video.paused) video.play().catch(syncButton);
          else video.pause();
        }, options);
        video.addEventListener('play', syncButton, options);
        video.addEventListener('pause', syncButton, options);
        video.addEventListener('error', () => { button.hidden = true; }, options);

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const respectMotion = () => {
          if (reduceMotion.matches) {
            video.autoplay = false;
            video.pause();
          }
        };
        reduceMotion.addEventListener('change', respectMotion, options);
        if (reduceMotion.matches) respectMotion();
        else video.play().catch(syncButton);
        syncButton();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iphone-launch-ar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('promo-trio-v2')) {
    customElements.define('promo-trio-v2', class extends HTMLElement {
      connectedCallback() {
        this.cleanup();
        this.events = new AbortController();
        this.setupCountdown();
        this.setupVideo();
      }

      disconnectedCallback() {
        this.cleanup();
        this.video?.pause();
      }

      cleanup() {
        window.clearInterval(this.interval);
        this.interval = null;
        this.events?.abort();
      }

      setupCountdown() {
        const timers = Array.from(this.querySelectorAll('[data-countdown]'));
        if (!timers.length) return;

        const inEditor = this.dataset.editor === 'true';
        const shape = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|[+-]\d{2}:\d{2})$/i;

        const parseDeadline = (value) => {
          const raw = (value || '').trim();
          const parts = raw.match(shape);
          const parsed = Date.parse(raw);
          const validCalendar = parts && Number(parts[1]) >= 1000
            && Number(parts[2]) >= 1 && Number(parts[2]) <= 12
            && Number(parts[3]) >= 1
            && Number(parts[3]) <= new Date(Date.UTC(Number(parts[1]), Number(parts[2]), 0)).getUTCDate()
            && Number(parts[4]) <= 23 && Number(parts[5]) <= 59 && Number(parts[6]) <= 59;
          return validCalendar && Number.isFinite(parsed) ? parsed : null;
        };

        const groups = [];

        timers.forEach(timer => {
          const units = timer.querySelector('[data-units]');
          const error = timer.querySelector('[data-date-error]');
          const expired = timer.querySelector('[data-expired]');
          const deadline = parseDeadline(timer.dataset.end);

          if (deadline === null) {
            timer.hidden = !inEditor;
            if (units) units.hidden = true;
            if (expired) expired.hidden = true;
            if (error) error.hidden = false;
            return;
          }

          timer.hidden = false;
          if (units) units.hidden = false;
          if (error) error.hidden = true;

          groups.push({
            deadline,
            expired,
            fields: ['days', 'hours', 'minutes', 'seconds'].map(key => timer.querySelector(`[data-${key}]`))
          });
        });

        if (!groups.length) return;

        const update = () => {
          const now = Date.now();
          let running = 0;

          groups.forEach(group => {
            const remaining = Math.max(0, Math.ceil((group.deadline - now) / 1000));
            if (remaining > 0) running += 1;
            const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
            group.fields.forEach((field, index) => {
              if (!field) return;
              const value = String(values[index]).padStart(2, '0');
              if (field.textContent !== value) field.textContent = value;
              field.dataset.digits = String(Math.min(value.length, 4));
            });
            if (group.expired) group.expired.hidden = remaining > 0 || !group.expired.textContent.trim();
          });

          if (running === 0) {
            window.clearInterval(this.interval);
            this.interval = null;
          }
          return running;
        };

        if (update() > 0) this.interval = window.setInterval(update, 1000);
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) update();
        }, { signal: this.events.signal });
      }

      setupVideo() {
        this.video = this.querySelector('video');
        const button = this.querySelector('[data-video-toggle]');
        if (!this.video || !button) return;

        const video = this.video;
        const playIcon = button.querySelector('[data-play-icon]');
        const pauseIcon = button.querySelector('[data-pause-icon]');
        const syncButton = () => {
          button.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
          playIcon.toggleAttribute('hidden', !video.paused);
          pauseIcon.toggleAttribute('hidden', video.paused);
        };
        const options = { signal: this.events.signal };
        video.muted = true;
        button.hidden = false;
        button.addEventListener('click', () => {
          if (video.paused) video.play().catch(syncButton);
          else video.pause();
        }, options);
        video.addEventListener('play', syncButton, options);
        video.addEventListener('pause', syncButton, options);
        video.addEventListener('error', () => { button.hidden = true; }, options);

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const respectMotion = () => {
          if (reduceMotion.matches) {
            video.autoplay = false;
            video.pause();
          }
        };
        reduceMotion.addEventListener('change', respectMotion, options);
        if (reduceMotion.matches) respectMotion();
        else video.play().catch(syncButton);
        syncButton();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iphone-launch"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('promo-trio-v2')) {
    customElements.define('promo-trio-v2', class extends HTMLElement {
      connectedCallback() {
        this.cleanup();
        this.events = new AbortController();
        this.setupCountdown();
        this.setupVideo();
      }

      disconnectedCallback() {
        this.cleanup();
        this.video?.pause();
      }

      cleanup() {
        window.clearInterval(this.interval);
        this.interval = null;
        this.events?.abort();
      }

      setupCountdown() {
        const timers = Array.from(this.querySelectorAll('[data-countdown]'));
        if (!timers.length) return;

        const inEditor = this.dataset.editor === 'true';
        const shape = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|[+-]\d{2}:\d{2})$/i;

        const parseDeadline = (value) => {
          const raw = (value || '').trim();
          const parts = raw.match(shape);
          const parsed = Date.parse(raw);
          const validCalendar = parts && Number(parts[1]) >= 1000
            && Number(parts[2]) >= 1 && Number(parts[2]) <= 12
            && Number(parts[3]) >= 1
            && Number(parts[3]) <= new Date(Date.UTC(Number(parts[1]), Number(parts[2]), 0)).getUTCDate()
            && Number(parts[4]) <= 23 && Number(parts[5]) <= 59 && Number(parts[6]) <= 59;
          return validCalendar && Number.isFinite(parsed) ? parsed : null;
        };

        const groups = [];

        timers.forEach(timer => {
          const units = timer.querySelector('[data-units]');
          const error = timer.querySelector('[data-date-error]');
          const expired = timer.querySelector('[data-expired]');
          const deadline = parseDeadline(timer.dataset.end);

          if (deadline === null) {
            timer.hidden = !inEditor;
            if (units) units.hidden = true;
            if (expired) expired.hidden = true;
            if (error) error.hidden = false;
            return;
          }

          timer.hidden = false;
          if (units) units.hidden = false;
          if (error) error.hidden = true;

          groups.push({
            deadline,
            expired,
            fields: ['days', 'hours', 'minutes', 'seconds'].map(key => timer.querySelector(`[data-${key}]`))
          });
        });

        if (!groups.length) return;

        const update = () => {
          const now = Date.now();
          let running = 0;

          groups.forEach(group => {
            const remaining = Math.max(0, Math.ceil((group.deadline - now) / 1000));
            if (remaining > 0) running += 1;
            const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
            group.fields.forEach((field, index) => {
              if (!field) return;
              const value = String(values[index]).padStart(2, '0');
              if (field.textContent !== value) field.textContent = value;
              field.dataset.digits = String(Math.min(value.length, 4));
            });
            if (group.expired) group.expired.hidden = remaining > 0 || !group.expired.textContent.trim();
          });

          if (running === 0) {
            window.clearInterval(this.interval);
            this.interval = null;
          }
          return running;
        };

        if (update() > 0) this.interval = window.setInterval(update, 1000);
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) update();
        }, { signal: this.events.signal });
      }

      setupVideo() {
        this.video = this.querySelector('video');
        const button = this.querySelector('[data-video-toggle]');
        if (!this.video || !button) return;

        const video = this.video;
        const playIcon = button.querySelector('[data-play-icon]');
        const pauseIcon = button.querySelector('[data-pause-icon]');
        const syncButton = () => {
          button.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
          playIcon.toggleAttribute('hidden', !video.paused);
          pauseIcon.toggleAttribute('hidden', video.paused);
        };
        const options = { signal: this.events.signal };
        video.muted = true;
        button.hidden = false;
        button.addEventListener('click', () => {
          if (video.paused) video.play().catch(syncButton);
          else video.pause();
        }, options);
        video.addEventListener('play', syncButton, options);
        video.addEventListener('pause', syncButton, options);
        video.addEventListener('error', () => { button.hidden = true; }, options);

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const respectMotion = () => {
          if (reduceMotion.matches) {
            video.autoplay = false;
            video.pause();
          }
        };
        reduceMotion.addEventListener('change', respectMotion, options);
        if (reduceMotion.matches) respectMotion();
        else video.play().catch(syncButton);
        syncButton();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
